<template>
  <div>
    <v-dialog
      v-model="isOpened"
      persistent
      scrollable
      width="730px"
    >
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar color="primary darken-1" dark>
            <v-toolbar-title>Changer le mot de passe</v-toolbar-title>
            <v-spacer />
            <v-btn text icon color="white" @click="isOpened = false">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-toolbar color="deep-purple lighten-5" dense class="pa-0 font-weight-medium">
          {{ user.firstname }} {{ user.lastname }}
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-alert
            :value="true"
            class="mt-2"
            type="info"
          >
            Après avoir validé, vous ne reverrez plus ce mot de passe, prenez le en note maintenant
          </v-alert>
          <v-row justify="center" align="center" class="mt-8 mb-8">
            <div class="ml-5 mr-5">&nbsp;</div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon medium class="mr-5" @click="generatePassword()" v-on="on"><v-icon>autorenew</v-icon></v-btn>
              </template>
              <span>Régénérer</span>
            </v-tooltip>
            <v-col class="generated-password" ref="password">
              {{ generatedPassword }}
            </v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon medium class="ml-5" @click="copyPassword()" v-on="on"><v-icon outlined>file_copy</v-icon></v-btn>
              </template>
              <span>Copier</span>
            </v-tooltip>
            <div class="ml-5 mr-5">&nbsp;</div>
          </v-row>
          <span class="black--text">
            Longueur du mot de passe ({{ this.passwordLength }})
          </span>
          <v-slider
            v-model="passwordLength"
            :tick-labels="ticksPasswordLengthLabel"
            class="mr-2"
            step="2"
            ticks="always"
            min="6"
            max="20"
            color="primary darken-1"
          ></v-slider>
          <v-switch
            v-model="isPasswordEasilyRemembered"
            class="black--text"
            color="primary darken-1"
            label="Mot de passe facilement mémorisable"
            input-value="true"
          ></v-switch>
          <v-switch
            v-model="isPasswordWithSpecialCharacters"
            class="black--text"
            color="primary darken-1"
            label="Peut inclure des caractères spéciaux"
            :disabled="isPasswordEasilyRemembered"
          ></v-switch>
          <v-row>
            <v-spacer />
            <v-btn text class="mr-3 mb-2" @click="isOpened = false">Annuler</v-btn>
            <v-btn :disabled="!$canWrite" color="primary darken-1" class="mr-3 mb-2" :loading="isSavingPassword" @click="$canWrite && (savePassword($event))">Attribuer ce mot de passe</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: `UserPasswordDialog`,
  props: [`value`],
  data: () => ({
    passwordLength: 8,
    isPasswordEasilyRemembered: true,
    isPasswordWithSpecialCharacters: false,
    isSavingPassword: false,
    ticksPasswordLengthLabel: [
      `6`,
      ``,
      ``,
      ``,
      ``,
      ``,
      ``,
      `20`,
    ],
    generatedPassword: ``,
  }),
  computed: {
    ...mapState(`model/user`, {
      user: `currentUser`,
    }),
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initLocalState();
        this.generatePassword();
      }
    },
    isPasswordEasilyRemembered() {
      this.generatePassword();
    },
    isPasswordWithSpecialCharacters() {
      this.generatePassword();
    },
    passwordLength() {
      this.generatePassword();
    },
  },
  methods: {
    async savePassword() {
      this.isSavingPassword = true;
      await this.$store.dispatch(`model/user/saveCurrentUserPassword`, { newPassword: this.generatedPassword });
      this.isSavingPassword = false;
      this.$store.commit(`SHOW_SNACKBAR`, {
        color: `success`,
        message: `Nouveau mot de passe enregistré`,
      });
      this.isOpened = false;
    },
    pickRandomCharFrom(characters) {
      return characters.charAt(Math.floor(Math.random() * characters.length));
    },
    generatePassword() {
      let password = ``;
      const alphabet = `abcdefghijklmnopkrstuvwxyz`;
      const numbers = `0123456789`;
      const specialCharacters = `!@#$+-*&_`;
      const consonants = `bcdfghjklmnpqrstvwxz`;
      const vowels = `aeiouy`;
      let characters = `${alphabet}${numbers}`;
      if (this.isPasswordWithSpecialCharacters) {
        characters = `${characters}${specialCharacters}`;
      }
      for (let i = 0; i < this.passwordLength; i += 1) {
        if (this.isPasswordEasilyRemembered) {
          if (i < this.passwordLength - 2) {
            characters = i % 2 === 0 ? consonants : vowels;
          } else {
            characters = numbers;
          }
        }
        password += this.pickRandomCharFrom(characters);
      }
      this.generatedPassword = password;
    },
    copyPassword() {
      const range = document.createRange();
      range.selectNode(this.$refs.password);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand(`copy`);
      window.getSelection().removeAllRanges();
    },
    initLocalState() {
      this.passwordLength = 8;
      this.isPasswordEasilyRemembered = true;
      this.isPasswordWithSpecialCharacters = false;
    },
  },
};
</script>

<style lang="scss">
  .v-label{
    color: black!important;
  }

  .generated-password {
    text-align: center;
    letter-spacing: 5px;
    font-size: 30px;
    border: 2px solid #5C33E2;
    padding: 20px 5px;
    border-radius: 3px;
    line-height: 30px;
    color: #333;
  }
</style>
